import React, { Component } from "react"

import { Segment, Icon, Grid, Image } from "semantic-ui-react"
import "./Fonctions.css"
import CalculsPro from "../../../assets/LandingPageMTP/Calculs_Pro.png"
import DevisFacture from "../../../assets/LandingPageMTP/Devis_Factures.png"
import referentiel from "../../../assets/LandingPageMTP/Réference_produits.png"
import exportEmail from "../../../assets/LandingPageMTP/Exports_emails.png"
import commande from "../../../assets/LandingPageMTP/Commandes_Fournisseurs_magasins.png"
import stock from "../../../assets/LandingPageMTP/Stocks.png"
import phonePC from "../../../assets/img/landing_pro_image_hero.png"

class Fonctions extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Segment id="blocFonctions">
        {" "}
        <Segment id="blocFonctionsTitle">
          <h1 id="titleFonctions">FONCTIONS</h1>
          <h2 id="titleFonctions">Les fonctionnalités dont vous avez besoin</h2>
        </Segment>
        <Grid divided columns="equal" id="gridFonctions">
          <Grid.Column id="blocColumn">
            <Image src={CalculsPro} id="imageFonctions" />
            <h4>Calculs Pro</h4>
          </Grid.Column>
          <Grid.Column id="blocColumn">
            <Image src={DevisFacture} id="imageFonctions" />
            <h4>Devis/Factures</h4>
          </Grid.Column>
          <Grid.Column id="blocColumn">
            <Image src={referentiel} id="imageFonctions" />
            <h4>
              Réferentiel
              <br /> produits
            </h4>
          </Grid.Column>
          <Grid.Column id="blocColumn">
            <Image src={exportEmail} id="imageFonctions" />
            <h4>Exports/emails</h4>
          </Grid.Column>
          <Grid.Column id="blocColumn">
            <Image src={commande} id="imageFonctions" />
            <h4>
              Commandes <br />
              Fournisseurs/magasins
            </h4>
          </Grid.Column>
          <Grid.Column id="blocColumn">
            <Image src={stock} id="imageFonctions" />
            <h4>Stocks</h4>
          </Grid.Column>
        </Grid>
        <Grid columns="equal">
          <Grid.Column>
            <Image src={phonePC} id="phonePC" />
          </Grid.Column>
          <Grid.Column>
            <h2>Référentiel produits ou importez vos données</h2>
            <p id="paragrapheFonctions">
              Quam ob rem vita quidem talis fuit vel fortuna vel gloria, ut
              nihil posset accedere, moriendi autem sensum celeritas abstulit;
              quo de genere mortis difficile dictu est; quid homines
              suspicentur, videtis; hoc vere tamen licet dicere, P. Scipioni ex
              multis diebus, quos in vita celeberrimos laetissimosque viderit,
              illum diem clarissimum fuisse, cum senatu dimisso domum reductus
              ad vesperum est a patribus conscriptis, populo Romano, sociis et
              Latinis, pridie quam excessit e vita, ut ex tam alto dignitatis
              gradu ad superos videatur deos potius quam ad inferos pervenisse.
            </p>
          </Grid.Column>
        </Grid>
      </Segment>
    )
  }
}

export default Fonctions



// WEBPACK FOOTER //
// ./src/components/Pro/AcceuilLandingPage/Fonctions.js